// extracted by mini-css-extract-plugin
module.exports = {"container":"until-fixed_container__2Dse_","date":"until-fixed_date__3EItR","zone":"until-fixed_zone__22pwb until-fixed_date__3EItR","title":"until-fixed_title__1BWsB"};